// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2G4HX","badges":"styles_badges__1ZLhB"};